export const MEMES2020 =
  process.env.NODE_ENV === 'development' ? '/api/memes2020' : '/memes2020'

export const UPLOAD_LOGO =
  process.env.NODE_ENV === 'development'
    ? '/api/match/fileupload'
    : '/match/fileupload'
